

import { HiOutlinePencilSquare } from "react-icons/hi2";

const NoteIcon = () => (
	<HiOutlinePencilSquare className="w-6 h-6 text-inherit" />
);

export default NoteIcon;
